module.exports = __webpack_public_path__ + "static/windheader2-505dcd4c18d0bd3453594e8b1446a159.mp4";